import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import TeamPage from "@/pages/TeamPage";
import TeamMemberPage from "@/pages/TeamMemberPage";
import ElSalvadorUsaPage from "@/pages/ElSalvadorUsaPage";
import ElSalvadorUsaSectionPage from "@/pages/ElSalvadorUsaSectionPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage, { PrivacyPage } from "@/pages/NotFoundPage";

let lenisInstance = null;

const useSmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const SiteShell = () => {
  const { lang } = useParams();
  useSmoothScroll();

  if (lang !== "es" && lang !== "en") {
    return <Navigate to="/es" replace />;
  }

  return (
    <LanguageProvider lang={lang}>
      <ScrollToTop />
      <Header />
      <main id="main-content">
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="services/:serviceId" element={<ServiceDetailPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team/:memberId" element={<TeamMemberPage />} />
          <Route path="el-salvador-ee-uu" element={<ElSalvadorUsaPage />} />
          <Route path="el-salvador-ee-uu/:sectionId" element={<ElSalvadorUsaSectionPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-center" />
    </LanguageProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/es" replace />} />
          <Route path="/:lang/*" element={<SiteShell />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
